import $ from 'jquery';
import { debounce } from '../../utils/debounce';

const headerOffset = () => {
	const el = {
		header: '.elementor-location-header',
		adminbar: '#wpadminbar',
	};

	const init = () => {
		$(function () {
			if (!$(el.header).length) return;
			exec();

			$(window).on('resize', debounce(exec, 150));
		});
	};

	const exec = () => {
		const adminbarHeight =
			window.innerWidth < 601 ? 0 : Math.ceil($(el.adminbar).height());
		$(el.header).css('--adminbar', adminbarHeight + 'px');
	};

	init();
};

try {
	headerOffset();
} catch (error) {
	console.error(error);
}
